module.exports = __webpack_public_path__ + "static/media/truth.39ec0ac4.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/truth.jpg
 ** module id = 441
 ** module chunks = 0
 **/